<script setup lang="ts">
import { computed } from 'vue';

export interface DataItem {
  type: string;
  volume: string;
  weight: string;
}

export interface Props {
  data?: DataItem[];
  totalData?: {
    volume?: string;
    weight?: string;
  };
}
const props = withDefaults(defineProps<Props>(), {
  data: () => [],
  totalData: () => {
    return {
      volume: undefined,
      weight: undefined,
    };
  },
});

// TODO
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
const totalData = computed(() => props.totalData || {});
</script>

<template>
  <table
    data-testid="airRoadJobsProductsCustomTable"
    :class="$style.airRoadJobsProductsCustomTable"
  >
    <thead>
      <tr>
        <th :class="$style.typeTh">Type</th>
        <th :class="$style.volumeTh">Volume</th>
        <th :class="$style.weightTh">Weight</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(dataItem, dataItemIndex) in data" :key="dataItemIndex">
        <tr>
          <td>{{ dataItem.type }}</td>
          <td class="whitespace-nowrap">{{ dataItem.volume }}</td>
          <td class="whitespace-nowrap">{{ dataItem.weight }}</td>
        </tr>
      </template>
    </tbody>
    <tfoot>
      <tr>
        <th :class="$style.totalTh">Total:</th>
        <td class="whitespace-nowrap">{{ totalData.volume }}</td>
        <td class="whitespace-nowrap">{{ totalData.weight }}</td>
      </tr>
    </tfoot>
  </table>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.airRoadJobsProductsCustomTable {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
  line-height: 1.4;
  text-align: left;

  th {
    font-weight: 500;
  }
  th, td {
    padding: 4px 12px;
  }
  th:first-child,
  td:first-child {
    padding-left: 0;
  }
  th:last-child,
  td:last-child {
    padding-right: 0;
  }
  tbody > tr:first-child > td {
    padding-top: 8px;
  }
  tbody > tr:last-child > td {
    padding-bottom: 8px;
  }

  tfoot th,
  tfoot td {
    padding-top: 8px;
    border-top: 1px solid colors.$color-gray-300;
  }
}
  .typeTh {
    width: 100%;
  }
</style>
